import script from "./myExchangeCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./myExchangeCoupon.vue?vue&type=script&setup=true&lang=js"

import "./myExchangeCoupon.vue?vue&type=style&index=0&id=5ef3bfcc&scoped=true&lang=less"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef3bfcc"]])

export default __exports__